import React from "react";

import { Separator } from "../Headers/Separator";
import Carousel from 'react-multi-carousel';
import { CardEventosFinales } from "./CardEventosFinales";
import { differenceInDays, format } from "date-fns";
// import { es } from 'date-fns/locale/es'
// import { Timestamp } from 'firebase/firestore/lite';
import 'react-multi-carousel/lib/styles.css';
import '../../styles/EventosFinales.css';



const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };




export const EventosFinales = (props) =>{
    let eventos = (props.events) ? props.events.filter( (event) => new Date(event.startDate.seconds*1000) < new Date() ) : [] ;
    if ( eventos.length <= 0)
    {
        return null;
    }
    return(
        <section id="EventosFinales" className="section">
            <Separator name ='Eventos Finalizados'/>

            <div className="container">
                <Carousel 
                responsive={responsive}
                showDots={true}
                containerClass="carousel-container"
                > 
                    { 
                        eventos.map( (elem, idx) =>{
                            let dateStr = "";
                            if ( !elem.startDate )
                            {
                                return null;
                            }
                            const startDate = new Date(elem.startDate.seconds*1000);
                            const endDate = new Date(elem.endDate.seconds*1000);
                            const difference = differenceInDays(endDate, startDate);
                            if ( difference >= 28 )
                            {
                                dateStr = new Intl.DateTimeFormat("es-MX", {"month": "long"}).format(startDate) + " " + startDate.getFullYear();
                                dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
                            }
                            else
                            {
                                dateStr = format(startDate, 'dd/MM/yy') + ' - ' + format(endDate, 'dd/MM/yy');
                            }
                            return(
                                <CardEventosFinales idx={idx} key={elem}  name ={elem.title} foto={elem.url_image} uni={elem.content} linea={dateStr}></CardEventosFinales>
                            )
                        })
                    }
                </Carousel>
            </div>


        </section>
    )
}